/* 搜索文件的modal controller */
module.exports = ['$scope', 'netFolderService', '$state', '$sce', '$utils', '$ionicScrollDelegate',
  function ($scope, netFolderService, $state, $sce, $utils, $ionicScrollDelegate) {
    const LOAD_LIMIT = 50
    const allFileList = []
    let lastFileListLength

    $scope.goBack = function () {
      $scope.$emit('closeSearchModal', true)
    }

    /* 搜索先搜索文件夹,再搜索文件,其中用_handleHightlight对名称进行高亮处理 */
    $scope.search = function (keyword) {
      $scope.searching = true
      $scope.noResultFound = false
      $scope.searchFilesList = []
      $scope.searchFolderList = []
      lastFileListLength = 0
      $utils.$uiHelper.scrollToTop('searchFileContent')
      netFolderService.searchFolders($scope.folderId, keyword, $scope.folderType).then(function (data) {
        const folderList = data['var']
        for (let i = 0; i < folderList.length; i++) {
          folderList[i].highLightName = _handleHighLight(keyword, $utils.$html.encode(folderList[i].name))
        }

        $scope.searchFolderList = folderList
        searchFile(keyword)
      }, function (e) {
        searchFile(keyword)
      })
    }

    function searchFile(keyword) {
      const loadOptions = {
        start: $scope.searchFilesList.length,
        limit: LOAD_LIMIT
      }
      netFolderService.searchFiles($scope.folderId, keyword, $scope.folderType, loadOptions).then(function (data) {
        if (data && data.code === 'S_OK') {
          data.var.forEach(function (item) {
            item.formattype = $utils.$attachment.getIconClass(item.attn, item.contentType)
          })
          $scope.searchFilesList = $scope.searchFilesList.concat(data['var'])
          $ionicScrollDelegate.resize()
          // for (let i = 0, length = $scope.searchFilesList.length; i < length; i++) {
          //   $scope.searchFilesList[i].highLightName = _handleHighLight(keyword, $utils.$html.encode($scope.searchFilesList[i].name))
          // }
          $scope.lastKeyword = keyword
          $scope.searching = false
          $scope.noResultFound = !!(($scope.searchFilesList.length == 0 && $scope.searchFolderList == 0))
          if (data['var'].length < LOAD_LIMIT || $scope.searchFilesList.length == lastFileListLength) {
            $scope.hasMoreFiles = false
          } else {
            $scope.hasMoreFiles = true
          }
          lastFileListLength = $scope.searchFilesList.length
          $scope.$broadcast('scroll.infiniteScrollComplete')
        }
      }, function (e) {
        console.log(e)
        $scope.lastKeyword = keyword
        $scope.searching = false
      })
    }
    // 搜索来往附件
    $scope.doneSearch = false
    $scope.searchAttachments = function(keyword) {
      $scope.searchAttachmentsList = []
      const options = {
        start: 0,
        limit: 20,
        attn: keyword
      }
      $scope.searching = true
      netFolderService.listAttachments(options).then(function(data) {
        if (data && data.code === 'S_OK') {
          data.var.forEach(function(item) {
            item.formattype = $utils.$attachment.getIconClass(item.attn, item.contentType)
          })
          $scope.searchAttachmentsList = $scope.searchAttachmentsList.concat(data.var) || []
          $scope.noResultFound = $scope.searchAttachmentsList.length === 0
          $scope.noMoreAttachment = $scope.searchAttachmentsList.length === data.total
          $ionicScrollDelegate.resize()
        }
      }, function(error) {
        console.log(error)
      }).finally(function() {
        $scope.lastKeyword = keyword
        $scope.searching = false
        $scope.doneSearch = true
      })
    }
    $scope.searchMoreAttachments = function() {
      $scope.isLoadingMore = true
      const options = {
        start: $scope.searchAttachmentsList.length,
        limit: 20
      }
      netFolderService.listAttachments(options).then(function(data) {
        if (data && data.code === 'S_OK') {
          data.var.forEach(function(item) {
            item.formattype = $utils.$attachment.getIconClass(item.attn, item.contentType)
          })
          $scope.searchAttachmentsList = $scope.searchAttachmentsList.concat(data.var) || []
          $scope.noResultFound = $scope.searchAttachmentsList.length === 0
          $scope.noMoreAttachment = $scope.searchAttachmentsList.length === data.total
          $ionicScrollDelegate.resize()
        }
      }, function(error) {
        console.log(error)
      }).finally(function() {
        $scope.isLoadingMore = false
      })
    }
    $scope.loadMore = function () {
      if ($scope.lastKeyword && !$scope.searching) {
        $scope.searching = true
        searchFile($scope.lastKeyword)
      }
    }

    function _checkIfMoreFile() { //eslint-disable-line
      return $scope.searchFilesList.length < allFileList.length
    }

    // 用于处理搜索结果关键字高亮,使用插入标签的方法,显示需要使用ng-html-bind的方法
    function _handleHighLight(keyword, filename) {
      const pattern = new RegExp(keyword, 'i')
      const tempName = filename.replace(pattern, "<span class='highlight'>$&</span>")
      return $sce.trustAsHtml(tempName) // 使用sce过滤ng才允许直接嵌入标签
    }
  }]



// WEBPACK FOOTER //
// ./src/js/netFolder/searchFileCtrl.js